<template>
  <div class="content">
    <revision-form :datas="dataall"></revision-form>
    <kontragent :datas="dataall"></kontragent>
    <sklad :datas="dataall"></sklad>
    <paytype :datas="dataall"></paytype>
    <product :datas="dataall"></product>
    <unit></unit>
    <model></model>
    <brand></brand>
    <colour></colour>
    <country></country>
    <firma></firma>
    <b-modal id="modal-close" centered>
      <h4>
        {{$t('Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?')}}
      </h4>

      <template #modal-footer="{ ok, cancel, hide }">
        <button type="button" class="btn btn-success" style="margin-bottom: 16px;"
          @click="$root.$refs.revision.Savedokument()">{{$t('Да')}}</button>
        <button type="button" class="btn btn-danger" @click='Home()'>{{$t('Нет')}}</button>
        <button type="button" class="btn btn-primary" @click="cancel()">{{$t('Отмена')}}</button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import {
  Firma,
  RevisionForm,
  Kontragent,
  Sklad,
  Paytype,
  Product,
  Unit,
  Model,
  Country,
  Brand,
  Colour
} from "@/pages";
export default {
  components: {
    Firma,
    RevisionForm,
    Kontragent,
    Sklad,
    Paytype,
    Country,
    Product,
    Unit,
    Model,
    Brand,
    Colour
  },
  data() {
    return {
      watch: false,
      update_password: "",
      dataall: {}
    };
  },
  watch: {
    dataall: {
      deep: true,
      handler(val, oldVal) {
        this.$store.state.saved += 1;
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.saved <2) {
      this.$store.state.saved = null;
      next();
    } else {
      this.$bvModal.show("modal-close");
    }
  },
  mounted() {
    this.Data();
    this.Sklad();
  },
  methods: {
    Home() {
        this.$store.state.saved = null;
        this.$bvModal.hide('modal-close');
        this.$router.push({ name: "Ревизия" });
      },
    Data() {
      let self = this;
      axios
        .get("api/v1/revision/id/" + self.$route.params.id)
        .then(function(response) {
          self.dataall = response.data;
          setTimeout(() => {
            // self.$root.$refs.revision.Update();
            setTimeout(() => {
              self.watch = true;
            }, 1000);
          }, 100);
          // self.$root.$refs.revision.Productlistfolder(response.data.sklad_id,0);
        });
    },
    Sklad() {
      let self = this;
      axios
        .get("api/v1/sklads/id/" + localStorage.getItem("sklad_id"))
        .then(function(response) {
          self.update_password = response.data.update_password;
        });
    }
  }
};
</script>
